// extracted by mini-css-extract-plugin
export default {"container":"MentionsInput_container__Ic5de","d-flex":"MentionsInput_d-flex__wft8t","icon":"MentionsInput_icon__51qnE","default":"MentionsInput_default__HQU0W"};